var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 5.0001C28.771 4.56236 29.2907 4.21512 29.8626 3.97822C30.4345 3.74132 31.0475 3.61938 31.6666 3.61938C32.2856 3.61938 32.8986 3.74132 33.4706 3.97822C34.0425 4.21512 34.5622 4.56236 34.9999 5.0001C35.4377 5.43784 35.7849 5.95751 36.0218 6.52944C36.2587 7.10138 36.3806 7.71437 36.3806 8.33343C36.3806 8.95249 36.2587 9.56548 36.0218 10.1374C35.7849 10.7094 35.4377 11.229 34.9999 11.6668L12.4999 34.1668L3.33325 36.6668L5.83325 27.5001L28.3333 5.0001Z",
    stroke: "#374151",
    strokeWidth: 3.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.75c7ace77be259ea8fac3701fea2d2e9.svg";
export { ForwardRef as ReactComponent };